import Main from '@/components/tables/partials/Main';
export default {
  components: {
    Main
  },
  data() {
    return {
      headers: [{
        key: 'photo',
        label: ''
      }, {
        key: 'name',
        sortable: true
      }, {
        key: 'email',
        sortable: true
      }, {
        key: 'needspatientreplydatetime',
        label: 'In Stage',
        sortable: true
      }, {
        key: 'datetimelastaction',
        label: 'Last Action',
        sortable: true
      }, {
        key: 'request',
        label: 'Actions'
      }, {
        key: 'actions',
        label: 'asdfasdf'
      }, {
        key: 'history',
        label: ''
      }, {
        key: 'links',
        label: ''
      }],
      type: 'doctorrequest'
    };
  },
  methods: {
    viewInfo(row) {
      this.$emit('view-info', row);
    },
    getStatusCount() {
      this.$emit('get-status-count');
    }
  }
};